import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Chip } from '@mui/material';
import './StatusTabs.css';

const StatusTabs = ({ statuses, activeStatus, onStatusChange, userRole, statusStylesSource }) => {
  const isRecruteur = userRole === 'recruteur';

  const normalizedStatuses = Object.entries(statuses).reduce((acc, [key, val]) => {
    const displayKey = isRecruteur && key === 'à traiter' ? 'postulée' : key;
    acc[displayKey] = acc[displayKey] ? acc[displayKey].concat(val) : val;
    return acc;
  }, {});

  const normalizedActiveStatus =
    isRecruteur && activeStatus === 'à traiter' ? 'postulée' : activeStatus;

  const totalCount = Object.values(normalizedStatuses).reduce((acc, arr) => acc + arr.length, 0);

  const entries = Array.isArray(statusStylesSource)
    ? statusStylesSource.map(({ value, style, label }) => [value.toLowerCase(), { style, label }])
    : Object.entries(statusStylesSource || {}).map(([key, val]) => [
        key.toLowerCase(),
        { style: val, label: val.label || key },
      ]);

  const styleMap = entries.reduce((acc, [key, val]) => {
    acc[key] = val.style;
    return acc;
  }, {});

  const labelMap = entries.reduce((acc, [key, val]) => {
    acc[key] = val.label;
    return acc;
  }, {});

  return (
    <Box className="statusTabsWrapper">
      <Button
        className={`statusBtn ${normalizedActiveStatus === null ? 'active' : ''}`}
        onClick={() => onStatusChange(null)}
        variant="outlined"
      >
        Tous
        <Chip label={totalCount} size="small" className="statusChip" />
      </Button>

      {Object.entries(normalizedStatuses).map(([status, items]) => {
        const originalKey = isRecruteur && status === 'postulée' ? 'à traiter' : status;
        const lowerKey = originalKey.toLowerCase();
        const style = styleMap[lowerKey] || {};
        const label = labelMap[lowerKey] || status;
        const isActive = status === normalizedActiveStatus;

        return (
          <Button
            key={status}
            className={`statusBtn ${isActive ? 'active' : ''}`}
            onClick={() => onStatusChange(originalKey)}
            variant={isActive ? 'contained' : 'outlined'}
            style={{
              borderColor: style.backgroundColor || '#ccc',
              backgroundColor: isActive ? style.backgroundColor || '#f0f0f0' : 'transparent',
              color: isActive ? '#fff' : '#333',
            }}
          >
            {label}
            <Chip
              label={items.length}
              size="small"
              className="statusChip"
              style={{
                backgroundColor: isActive ? '#fff' : style.backgroundColor,
                color: isActive ? style.backgroundColor : '#fff',
              }}
            />
          </Button>
        );
      })}
    </Box>
  );
};

StatusTabs.propTypes = {
  statuses: PropTypes.object.isRequired,
  activeStatus: PropTypes.string,
  onStatusChange: PropTypes.func.isRequired,
  userRole: PropTypes.string.isRequired,
  statusStylesSource: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
};

export default StatusTabs;
